<template>
	<div class="container">
		<el-row :gutter="5">
			<el-col :span="4">
				<h4 class="left_title">信息分类</h4>
				<el-menu :defaultActive="'1'" class="category-menu" background-color="#fff" text-color="#333">
					<el-menu-item v-for="(item,index) in categoryList" :key="index">
						<router-link :to="{path: '/category',query: { categoryId: item.id }}">
							{{item.name}}
							<i class="el-icon-arrow-right" />
						</router-link>
					</el-menu-item>
				</el-menu>
			</el-col>

			<el-col :span="20">
				<!-- <el-menu :defaultActive="activeMenu" class="top-nav-menu" background-color="#fff" text-color="#333"
					mode="horizontal" activeTextColor='#009933'>
					<el-menu-item v-for="(item,index) in categoryList" :key="index">
						<router-link to="/">
							{{item.name}}
						</router-link>
					</el-menu-item>
				</el-menu> -->

				<el-row :gutter="5" style="margin-top: 5px;">
					<el-col :span="24">
						<Banner :bannerList='bannerList' />
					</el-col>

					<!-- <el-col :span="7">
						<el-tabs v-model="activeTab" class="right-card">
							<el-tab-pane label="首页置顶" name="1">
								<el-empty description="暂无首页置顶信息" :imageSize='80' />
							</el-tab-pane>
							<el-tab-pane label="热点资讯" name="2">
								<el-empty description="暂无热点资讯信息" :imageSize='80' />
							</el-tab-pane>
							<el-tab-pane label="网站公告" name="3">
								<el-empty description="暂无网站公告信息" :imageSize='80' />
							</el-tab-pane>
						</el-tabs>
					</el-col> -->
				</el-row>
			</el-col>
		</el-row>

		<el-row :gutter="5" style="margin-top: 5px;">
			<el-col :span="24">
				<BrandRecommend />
			</el-col>
		</el-row>

		<el-row :gutter="5" style="margin-top: 5px;">
			<blockquote v-for="(item,index) in infoList" :key="index">
				<el-col :span="12" style="margin-bottom: 5px;" v-if="item.length!=0">
					<InfoList :title="item[0].categoryPName" iconClass="el-icon-house" :list="item"
						@goMore="getMoreInfo(item[0])" />
				</el-col>
				<el-col :span="24" style="margin-bottom: 5px;" v-else>
					<img class="ad_image" :src="bannerList[Math.floor(Math.random() * bannerList.length)].imgUrl" />
				</el-col>
			</blockquote>
		</el-row>
	</div>
</template>

<script>
	// 引入复用组件
	import Banner from '@/components/Banner.vue'
	import BrandRecommend from '@/components/BrandRecommend.vue'
	import InfoList from '@/components/InfoList.vue'

	// 引入接口（后续对接后端）
	import {
		getCMSList
	} from '@/api/info'


	import {
		getCategories,
		getBannerList
	} from '@/api/category.js'

	export default {
		name: 'Home',
		components: {
			Banner,
			BrandRecommend,
			InfoList
		},

		data() {
			return {
				activeTab: '1',
				// 当前激活的文档
				activeMenu: '1',


				bannerList: [],
				/**
				 * 分类信息的列表
				 */
				categoryList: [],
				infoList: []
			}
		},


		mounted() {
			// 页面加载后请求真实数据
			this.loadData()
			this.getCategories()
		},


		methods: {

			/**
			 * 下载分类信息的列表
			 */
			async getCategories() {
				const temResult = await getCategories(0)
				if (temResult.code == 200) {
					this.categoryList = []
					this.categoryList = temResult.data
				}
			},

			async loadData() {
				try {
					const bannerResult = await getBannerList()
					if (bannerResult.code == 200) {
						this.bannerList = []
						this.bannerList = bannerResult.data
					}
					// 房屋租售数据
					const infoList = await getCMSList({
						tenantId: '102657'
					})
					if (infoList.code == 200) {
						this.infoList = []
						this.infoList = infoList.data
						console.log(this.bannerList[0])
					}
				} catch (error) {
					this.$message.error('数据加载失败')
				}
			},



			async getMoreInfo(item) {
				this.$router.push({
					path: '/category',
					query: {
						categoryId: item.categoryPId
					}
				});
			}
		}
	}
</script>

<style scoped>
	.left_title {
		background-color: forestgreen;
		padding: 10px;
		color: white;
	}


	::v-deep .category-menu .el-menu-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 45px !important;
		line-height: 45px !important;
		padding: 0 20px !important;

		a {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			color: #333;

			&:hover {
				color: #009933;
			}

			i {
				font-size: 20px;
				color: #333;
			}
		}
	}


	.top-nav-menu {
		.el-menu-item {
			padding: 0 15px !important;
		}
	}



	.right-card {
		height: 397px;
		background-color: white;

		.right-tabs {

			height: 100%;

			.el-tabs__header {
				margin: 0;
			}

			.tab-content-list {
				padding: 20px 10px;

				li {
					padding: 5px 0;
					font-size: 14px;
					color: #666;
				}
			}

			.empty-tip {
				color: #999;
				font-size: 14px;
			}
		}
	}


	.ad_image {
		width: 100%;
		height: 60px;
		border-radius: 5px;
	}
</style>